import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { SocialCoin } from '../../../components/SocialCoin/SocialCoin';
import { CrownRoundedIcon } from '../../../components/SVGIcons/CrownRoundedIcon';
import styles from '../Onboarding.module.scss';

export const SocialCoinTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <>
      <p data-testid="onboarding-social-coin-tooltip-text">
        <Trans
          components={{
            intro: <span />,
            coins: (
              <span className={styles.coinImage}>
                <CrownRoundedIcon />
                <SocialCoin />
              </span>
            ),
            bold: <strong />,
            outro: <span />,
          }}
          i18nKey="onboarding.playWithCrownCoins"
        />
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('buttons.great')}
      </Button>
    </>
  );
};
